import { render, staticRenderFns } from "./Trans.vue?vue&type=template&id=734c4e67"
import script from "./Trans.vue?vue&type=script&lang=js"
export * from "./Trans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports